import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
import { jsx as _jsx } from "react/jsx-runtime";
const renderGlyphsFromProps = glyphProps => glyphProps.map((glyphPropSet, index) => /*#__PURE__*/_jsx(Glyphicon, {
  ...glyphPropSet
}, index));

/**
 * The GlyphiconStack component is used to stack mulitple icons on top of each other.
 * The component accepts 2 Glyphicon components as child nodes.
 * Stacking will start with the first child on the bottom and the second on top.
 * The component currently only allows 2 icons to be stacked.
 * Individual coloring of icons should be handled at the child component level.
 * Overall sizing should be handled by passing a text-size utility class to the root component. The bottom Icon will be sized to 2x that supplied size.
 *
 * Note:
 * The use of 'topGlyphProps' & 'bottomGlyphProps' props has been deprecated in favor of passing Glyphicon child elements.
 **/
function GlyphiconStack(_ref) {
  let {
    className,
    children,
    resize = true,
    topGlyphProps,
    bottomGlyphProps,
    ...rest
  } = _ref;
  const containerClassName = clsx({
    'glyphicon-stack': true,
    'glyphicon-stack-resize': resize
  }, className);
  return /*#__PURE__*/_jsx("span", {
    "data-cmp": "glyphiconStack",
    ...rest,
    className: containerClassName,
    children: React.Children.count(children) > 0 ? children : renderGlyphsFromProps([bottomGlyphProps, topGlyphProps])
  });
}
export default GlyphiconStack;